import React, { useEffect } from "react";
import Dropdown from "../Dropdown";
import { Link,  } from "gatsby";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "../../contexts/TranslationContext";
import MobileDropdown from "../MobileDropdown";
import { NavItem } from "@/components/layout/Navbar";

export default function MobileNavbar({
  location,
  navItems,
  lang,
  open,
  toggleMenu,
}: {
  location: any;
  navItems: NavItem[];
  lang: string;
  open: boolean;
  toggleMenu: () => void;
}) {
  useEffect(() => {
    if (open) {
      document.querySelector("body")!.style.overflow = "hidden";
    } else {
      document.querySelector("body")!.style.overflow = "visible";
    }
  }, [open]);

  const { t } = useTranslation();

  const renderMobileNavItems = () => {
    return navItems.map((item: NavItem, index) => {
      if (item.dropdown) {
        return (
          <li key={index}>
            <MobileDropdown
              title={item.name}
              items={item.dropdown}
              path={item.dropdown[0].path!}
              active={location?.pathname?.indexOf(item.dropdown[0].path!) === 0}
              lang={lang}
              toggleMenu={toggleMenu}
            />
          </li>
        );
      } else {
        return (
          <li
            key={index}
            className={`py-4 cap-first text-gray-500 text-xl font-bold transition-all duration-500 underline-offset-8 decoration-2 ${location?.pathname === `/${lang}${item.path}` ? "text-primary" : ""}`}
          >
            <Link onClick={toggleMenu} to={item?.noLangPrefix ? item.path! : `/${lang}${item.path}`}>
              {t(item.name)}
            </Link>
          </li>
        );
      }
    });
  };

  return (
    <>
      {open && <div className="z-50 fixed inset-0 bg-[rgba(0,0,0,0.5)]" onClick={toggleMenu}></div>}
      <nav
        className={`fixed top-0 right-0 bg-white h-screen w-[300px] z-[51] p-8 transition duration-300 ${!open ? "translate-x-[300px]" : ""}`}
      >
        <button className="flex justify-end w-full" onClick={toggleMenu}>
          {" "}
          <XMarkIcon className="w-8 h-8" />{" "}
        </button>
        <ul className="h-full overflow-y-auto pb-10">{renderMobileNavItems()}</ul>
      </nav>
    </>
  );
}
